import { defineNuxtPlugin } from "#app";
import { useCompanyLoader } from "~/composables/useCompanyLoader";
import { useUserLoader } from "~/composables/useUserLoader";
import { useCountryLoader } from "~/composables/useCountryLoader";
import { useUiStore } from "~/stores/ui/uistore";
import { useAppTypesStore } from "~/stores/apptypesstore";
import { useLicenseContainerTypesStore } from "~/stores/licensecontainertypesstore";
import { useHardwareTypesStore } from "~/stores/hardwaretypesstore";
import { useDeployementInfoStore } from "~/stores/deploymentinfostore";

import { useCompaniesStore } from "~/stores/companiesstore";
import { useHubsStore } from "~/stores/hubsstore";
import { useCategoriesStore } from "~/stores/categoriesstore";
import { useCountriesStore } from "~/stores/countriesstore";
import { useLegalAddressCountryLoader } from "~/composables/useLegalAddressCountryLoader";
import { useDevicesCountLoader } from "~/composables/useDevicesCountLoader";
import { useLicenseCountLoader } from "~/composables/useLicenseCountLoader";
import { useConfigurationsStore } from "~/stores/configurationsstore";

/* plugins are loading while the page is loading so the spa-loading-template is shown */

export default defineNuxtPlugin({
  name: "preloadStores",
  async setup() {
    console.debug("preloadStores.client.ts loaded");
    const uiStore = useUiStore();
    const appTypesStore = useAppTypesStore();
    const licenseContainerTypesStore = useLicenseContainerTypesStore();
    const hardwareTypesStore = useHardwareTypesStore();
    const deploymentInfoStore = useDeployementInfoStore();
    const companiesStore = useCompaniesStore();
    const hubsStore = useHubsStore();
    const categoriesStore = useCategoriesStore();
    const countriesStore = useCountriesStore();
    const configurationsStore = useConfigurationsStore();
    const firmwareVersionsStore = useFirmwareVersionsStore();
    const userStore = useUserStore();

    // init reactive loaders
    useUserLoader();
    useCompanyLoader();
    useCountryLoader();
    useLegalAddressCountryLoader();
    useDevicesCountLoader();
    useLicenseCountLoader();
    useUserStore();

    const loadOther = async () => {
      await Promise.all([
        appTypesStore.loadAppTypes(),
        licenseContainerTypesStore.loadLicenseContainerTypes(),
        hardwareTypesStore.loadHardwareTypes(),
        deploymentInfoStore.loadDeploymentInfo(),
        companiesStore.loadCompanies(),
        hubsStore.loadHubs(),
        categoriesStore.loadCategories(),
        categoriesStore.loadCategoryGroups(),
        countriesStore.loadCountries(),
        configurationsStore.loadConfigurationVariables(),
        firmwareVersionsStore.getAllMajorMinorFirmwareVersions(),
        userStore.loadMfaDeviceTokenInfo(),
      ]);
    };
    await uiStore.checkBrowserCompatibility();
    await loadOther();
  },
});
